// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M12 1.19824L22 9.53158V22H2V9.53158L12 1.19824ZM10 20H14V15H10V20ZM16 20H20V10.4683L12 3.80166L4 10.4683V20H8V13H16V20Z"}}]};

const HomeIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'home',
    ref,
    icon: element,
  },
));

HomeIcon.displayName = 'HomeIcon';

export default HomeIcon;
